import { request, RequestOptions } from '@nextgen-web-framework/core';
import { cmsApi } from '@commerce-webcomponents/sdk';
import {
  BaseUrlReqPayloadType,
  Forbidden,
  FulfillmentCartPickupCollectionResponse,
  FulfillmentResponse,
  FulfillmentTypeCollectionResponse,
  FulfillmentTypeIdReqPayloadType,
  GetFulfillmentProps,
  getServiceLocationTypeProps,
  getStoresByFulfillmentTypeProps,
  getwarehousesByPostalCodeTypeProps,
  ServiceLocationApiResponse,
  serviceLocationIdReqPayloadType,
  WarehousesCollectionResponse,
} from '../../types/fulfillmentTypes';
import {
  getFulfillmentReqObj,
  BaseAPIUrl,
  getFulfillmentTypesReqObj,
  getStoresByFulfillmentTypeReqObj,
} from '../config';
import {
  cmsAPIVersion,
  cmsContentType,
  DefaultWarehouse,
  PostCode,
  ServiceLocationId,
} from '../config/fulfillmentApiConstants';
import {
  getServiceLocationsReqObj,
  getWarehousesByPostCodeTypeReqObj,
  getServiceLocationByIdReqObj,
} from '../config/fulfillmentApiEndPoints';
import { ServiceLocation } from '../models';

const defaultBaseApiUrl = ApiConfigService.getBaseUrl();
export const FulfillmentApi = {
  getFulfillment({
    baseUrl = defaultBaseApiUrl,
    payload,
  }: BaseUrlReqPayloadType & GetFulfillmentProps): Promise<FulfillmentResponse> {
    const req = { ...getFulfillmentReqObj };
    req.url = req.url.replace(BaseAPIUrl, baseUrl);
    req.body = payload as unknown as BodyInit;
    return handleRequest(req);
  },
  getFulfillmentTypes({
    baseUrl = defaultBaseApiUrl,
    params,
  }: BaseUrlReqPayloadType & FulfillmentTypeIdReqPayloadType): Promise<FulfillmentTypeCollectionResponse> {
    const req = { ...getFulfillmentTypesReqObj };
    req.params = params;
    req.url = req.url.replace(BaseAPIUrl, baseUrl);
    return handleRequest(req);
  },
  getStoresByFulfillmentType({
    baseUrl = defaultBaseApiUrl,
    payload,
  }: BaseUrlReqPayloadType & getStoresByFulfillmentTypeProps): Promise<FulfillmentCartPickupCollectionResponse> {
    const req = { ...getStoresByFulfillmentTypeReqObj };
    req.url = req.url.replace(BaseAPIUrl, baseUrl);
    req.body = payload as unknown as BodyInit;
    return handleRequest(req);
  },
  getWarehousesByPostCode({
    baseUrl = defaultBaseApiUrl,
    postCode = '',
    defaultWarehouse = false,
  }: getwarehousesByPostalCodeTypeProps): Promise<WarehousesCollectionResponse> {
    const req = { ...getWarehousesByPostCodeTypeReqObj };
    req.url = req.url.replace(BaseAPIUrl, baseUrl);
    req.url = req.url.replace(PostCode, postCode);
    req.url = req.url.replace(DefaultWarehouse, defaultWarehouse.toString());
    return handleRequest(req);
  },
  getServiceLocations({
    baseUrl = defaultBaseApiUrl,
    params,
  }: BaseUrlReqPayloadType & getServiceLocationTypeProps): Promise<FulfillmentTypeCollectionResponse> {
    const req = { ...getServiceLocationsReqObj };
    req.params = params;
    req.url = req.url.replace(BaseAPIUrl, baseUrl);
    return handleRequest(req);
  },

  getServiceLocationById({
    baseUrl = defaultBaseApiUrl,
    serviceLocationId,
  }: BaseUrlReqPayloadType & serviceLocationIdReqPayloadType): Promise<ServiceLocation | Forbidden> {
    const req = { ...getServiceLocationByIdReqObj };
    req.url = req.url.replace(ServiceLocationId, serviceLocationId);
    req.url = req.url.replace(BaseAPIUrl, baseUrl);
    return handleRequest(req);
  },

  getFulfillmentContentData() {
    return cmsApi.fetchContent({
      uId: cmsContentType,
      baseUrl: `${defaultBaseApiUrl}/comcontentstackas`,
      version: cmsAPIVersion,
    });
  },
};

const handleRequest = async (
  req: RequestOptions,
): Promise<
  FulfillmentResponse &
    FulfillmentTypeCollectionResponse &
    WarehousesCollectionResponse &
    FulfillmentCartPickupCollectionResponse &
    ServiceLocationApiResponse &
    ServiceLocation
> => {
  const response: FulfillmentResponse & ServiceLocation = await request(req, {
    skipIdempotency: false,
  });
  return Promise.resolve(response);
};
export default FulfillmentApi;
